import React from "react";
import "./detailOne.scss";
import smy from "../../assets/smy.png"
import jtBlue from "../../assets/jtBlue.png"
import datasetManage from "../../assets/datasetManage.png"
import datacontrol from "../../assets/datacontrol.png"
import akey1 from "../../assets/akey1.png"
import akey2 from "../../assets/akey2.png"
import akey3 from "../../assets/akey3.png"
import contentImg1 from "../../assets/contentImg1.png"
import contentImg2 from "../../assets/contentImg2.png"
import contentImg3 from "../../assets/contentImg3.png"
import contentImg4 from "../../assets/contentImg4.png"
import contentImg5 from "../../assets/contentImg5.png"
import contentImg6 from "../../assets/contentImg6.png"
import machine from "../../assets/machine.png";
import OSS_URL from "../../constants/ossUrl";


class DetailOne extends React.Component {
    render() {
        return <div className="detail-1">
            <div className="title">
                <div>NeuroScholar<sup>TM</sup>平台</div>
                <div> “一站式”解决方案</div>
            </div>
            <div className="part-1">
                <div className="img-1"><img src={smy}/></div>
                <div className="img-info">脑影像 原始数据</div>
            </div>
            <div className="arrow-bottom"><img src={jtBlue} /></div>
            <div className="part-2">
                
                <div className="content-2">
                    <div className="content-left">
                        <div className="title">
                            <div className="line"></div>
                            <div className="title-txt">灵活数据集管理</div>
                            <div className="title-bg"></div>
                            <div className="line"></div>
                        </div>
                        <div className="content-txt">
                            <img src={datasetManage} />
                        </div>
                    </div>
                    <img src={jtBlue} className="content-2-arrow"/>
                    <div className="content-right">
                        <div className="title">
                            <div className="line"></div>
                            <div className="title-txt">快速高效数据质控</div>
                            <div className="title-bg"></div>
                            <div className="line"></div>
                        </div>
                        <div className="content-txt">
                            <img src={datacontrol} />
                        </div>
                    </div>
                </div>
                <div className="content-3">
                    <div className="content-3-title">
                        <div className="content-3-title-line"></div>
                        <div className="content-3-title-txt">“一键式”完成复杂预处理</div>
                        <div className="title-gb"></div>
                        <div className="content-3-title-line"></div>
                    </div>
                    <div className="content-3-imgs">
                        <img src={akey1} />
                        <img src={akey2} className="center-img"/>
                        <img src={akey3} />
                    </div>
                </div>
                <img src={jtBlue} className="content-3-arrow"/>
                
                <div className="content-4">
                    <div className="content-4-title">
                        <div className="content-4-title-line"></div>
                        <div className="content-4-title-txt">“一键式”多模态数据分析与可视化</div>
                        <div className="title-gb"></div>
                        <div className="content-4-title-line"></div>
                    </div>
                    <ul className="content-4-imgs">
                        <li><img src={contentImg1}/></li>
                        <li><img src={contentImg2}/></li>
                        <li><img src={contentImg3}/></li>
                        <li className="img-v"><img src={contentImg4}/></li>
                        <li className="img-v"><img src={contentImg5}/></li>
                        <li><img src={contentImg6}/></li>
                    </ul>
                </div>
                <div style={{ marginTop: "4.2667rem" }}>
                    <div className="title">
                        <div className="line"></div>
                        <div className="title-txt">私有化部署的NeuroScholar<sup>TM</sup>平台</div>
                        <div className="line"></div>
                    </div>
                    <div className="content-1">
                        <div className="content-left">
                            <div className="title">NeuroScholar<sup>TM</sup>计算能力</div>
                            <div className="neuro-scholar-info">
                                <ul className="neuro-scholar-fun">
                                    <li>700以上逻辑核计算核心</li>
                                    <li>分布式数据备份</li>
                                    <li>搭载高性能计算显卡</li>
                                </ul>
                                <ul>
                                    <li>100TB以上有效存储</li>
                                    <li>2TB以上内存</li>
                                    <li>千兆/万兆网络</li>
                                </ul>
                            </div>
                        </div>
                        <img src={machine}/>
                        <div className="content-right">
                            <div className="title">机房需求</div>
                            <div className="neuro-scholar-info">
                                <ul className="neuro-scholar-fun">
                                    <li>配备双路电源</li>
                                    <li>额定功率≧22KW </li>
                                    <li>24小时制冷系统</li>
                                </ul>
                                <ul>
                                    <li></li>
                                    <li>额定电流≧100A</li>
                                    <li>接入内部网络</li>
                                </ul>
                                <ul>
                                    <li></li>
                                    <li>电源电压=220V</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
}      
export default DetailOne;